<template>
  <div style="padding-bottom:70px; padding-top:5px; padding-left:5px; padding-right:5px;">
    <v-container>
      <download-data :timeRange="timeRange" :organizationId="organizationId" :irrigationOrders1="irrigationOrders1" :irrigationOrders2="irrigationOrders2" :equipmentsData1="equipmentsData1" :equipmentsData2="equipmentsData2" />
    </v-container>
    <v-layout wrap>
      <v-flex xs12 md6>
        <h2 class="display-3 organization-name-title">LIAG</h2>
      </v-flex>
      <v-flex xs12 md6>
        <timeFilter :timeRange.sync="timeRange"></timeFilter>
      </v-flex>
	  </v-layout>
    <v-layout row>
      <v-flex xs12 sm6>
        <irrigation-orders-table limit=7 offset=0 pageNumber=1 :uniqueIrrigationOrders.sync="irrigationOrders1" :timeRange="timeRange" :organizationId="organizationId" />
      </v-flex>
      <v-flex xs12 sm6>
        <irrigation-orders-table limit=7 offset=7 pageNumber=2 :uniqueIrrigationOrders.sync="irrigationOrders2" :timeRange="timeRange" :organizationId="organizationId" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm3>
        <equipments-table limit=7 pageNumber=1 table :timeRange="timeRange" :organizationId="organizationId" />
      </v-flex>
      <v-flex xs12 sm3>
        <gruopedBarChart limit=7 offset=0 pageNumber=1 table :equipmentsData.sync="equipmentsData1" :timeRange="timeRange" :organizationId="organizationId" />
      </v-flex>
      <v-flex xs12 sm3>
        <equipments-table limit=7 pageNumber=2 :timeRange="timeRange" :organizationId="organizationId" />
      </v-flex>
      <v-flex xs12 sm3>
        <gruopedBarChart limit=7 offset=7 pageNumber=2 table :equipmentsData.sync="equipmentsData2" :timeRange="timeRange" :organizationId="organizationId" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import IrrigationOrdersTable from './IrrigationOrdersTable.vue'
  import EquipmentsTable from './EquipmentsTable.vue'
  import GroupedBarChart from './GroupedBarChart.vue'
  import TimeFilter from './TimeFilter.vue'
  import DownloadData from './DownloadData.vue'

  export default {
    components: {
      'irrigation-orders-table': IrrigationOrdersTable,
      'equipments-table': EquipmentsTable,
      'gruopedBarChart': GroupedBarChart,
      'timeFilter': TimeFilter,
      'download-data': DownloadData
    },
    data () {
      return {
        organizationId: 'gakIOzLeCqMGqJyTFXEY',
        timeRange: {
          from: new Date(this.$store.getters.timeRange.from),
          to: new Date(this.$store.getters.timeRange.to)
        },
        irrigationOrders1: [],
        irrigationOrders2: [],
        equipmentsData1: {},
        equipmentsData2: {}
      }
    },
    created () {
    },
    computed: {
      organizations () {
      }
    }
  }
</script>


// WEBPACK FOOTER //
// DashboardLiag.vue?d9da83c4